module.exports = __webpack_public_path__ + "img/s_atanasov.3082d93c.jpg";